import React from 'react';
import { Form, Input, Select, Button, Card, notification, DatePicker, InputNumber, AutoComplete, Modal, message } from 'antd';
import { MUNICIPALITY, PARISH } from '../../../utils/static-data';
import ConfigService, { OrganismService } from '../../../services/config.service';
import { getChildren, getCurrentUser, isPhone } from '../../../utils/utils';
import PicturesWall from './pictures/pictures-wall';
import ActivityService from '../../../services/activity.service';
import CoordinatesPicker from '../../coordinates-picker/coordinates-picker';
import './add-agenda.scss';

const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

class AddAgenda extends React.Component {

  wallOfPictures = React.createRef();

  state = {
    filteredParishes: [],
    sectors: [],
    measurement: [],
    searchingSectors: false,
    showMap: false,
    places: [],
    user: getCurrentUser(),
    task: {
      date: undefined,
      location: undefined,
      organism: undefined,
      status: undefined,
      title: undefined,
      description: undefined
    }
  }

  componentDidMount() {
    ConfigService.getMeasurement()
      .then(measurement => this.setState({ measurement }))
      .catch(err => { notification.error({ message: "Ha ocurrido un error al conectarse con los servidores." }) });
    this.getPlaces();
  }

  getPlaces = () => {
    OrganismService.getPlacesByOrganism(this.state.user.organism)
      .then(places => this.setState({ places }))
      .catch(err => message.error(err.toString()));
  }

  closeMap = () => {
    this.setState({ showMap: false });
  }

  openMap = () => {
    this.setState({ showMap: true });
  }

  handleNewPlace = (place) => {
    const { places } = this.state;
    places.push(place);
    this.setState({ places, showMap: false });
    this.props.form.setFields({ position: { value: place.id } });
  }

  render() {
    const { title } = this.props;
    return (
      <div>
        <Modal
          footer={null}
          closable={false}
          width="65vw"
          onCancel={this.closeMap}
          visible={this.state.showMap}>
          <CoordinatesPicker onSave={this.handleNewPlace} places={this.state.places} />
        </Modal>
        <h2>{title}</h2>
        <Card>
          <div className={isPhone() ? "" : "agenda-card"}>
            {this.agendaForm()}
          </div>
        </Card >
      </div>
    );
  }

  setParishes = municipality => {
    const { setFields } = this.props.form;
    setFields({ parish: null, sector: null });
    this.setState({
      filteredParishes: PARISH.filter(p => p.municipality === municipality)
    });
  }

  setSectors = async (parish) => {

    const { setFields } = this.props.form;
    setFields({ sector: null });

    this.setState({ searchingSectors: true });
    try {
      const sectors = await ConfigService.getSectors(parish);
      this.setState({ sectors: sectors.map(sector => sector.strdescripcion), searchingSectors: false });
    } catch (error) {
      notification.error({ message: 'No se han podido obtener los sectores pertenecientes a esta parroquia' });
      this.setState({ searchingSectors: false });
    }

  }

  rangePickerChange = range => {
    console.log(range);
  }

  handleSubmit = e => {
    const { fileList } = this.wallOfPictures.current.state;
    const { history } = this.props;

    e.preventDefault();
    this.props.form.validateFields(async (err, activity) => {
      if (!err) {
        const attachments = getAttachmentsIds(fileList);
        try {

          Object.keys(activity).forEach(key => {
            activity[key] === undefined && delete activity[key];
            key === 'date' && (activity[key] = activity[key].unix());
          });

          Object.assign(activity, { attachments });

          activity.other_sector && (activity.sector = activity.other_sector);

          await ActivityService.createActivity(activity);

          notification.success({ message: 'Actividad agendada' });
          this.props.form.resetFields();

          history.push('/mi-planificacion');

        } catch (error) {
          notification.error({ message: 'Ha Ocurrido un Error al agendar la actividad' });
        }

      }
    });
  };

  agendaForm = () => {
    const { getFieldDecorator } = this.props.form;
    const { fields, mode } = this.props;
    return (
      <Form onSubmit={this.handleSubmit} className="flex-form">
        {this.buildFields(getFieldDecorator, fields, mode)
          .map(field => field.item)}
      </Form>
    );
  }

  buildFields = (getFieldDecorator, fields, mode) => [
    {
      key: 'title',
      item: <Form.Item key='title' className="full-input" label="Titulo">
        {getFieldDecorator('title', {
          rules: [{ required: true, message: 'El titulo es requerido' }],
        })(
          <Input
            placeholder="Titulo del proyecto"
          />,
        )}
      </Form.Item>
    },

    {
      key: 'measurement',
      item: <Form.Item key='measurement' className="quarter-input" label="Medida">
        {getFieldDecorator('measurement', {
          rules: [{ required: (mode === 'planificacion'), message: 'La unidad de medida es requerida' }],
        })(
          <Select
            placeholder="Unidad de medida"
          >
            {this.state.measurement.map(
              (m, i) => <Option key={i} value={m.id}>{m.unit}</Option>
            )}
          </Select>,
        )}
      </Form.Item>
    },

    {
      key: 'meta',
      item: <Form.Item key='meta' className="quarter-input" label="Meta planificada">
        {getFieldDecorator('meta', {
          rules: [{ required: (mode === 'planificacion'), message: 'Este campo es requerido' }],
        })(
          <InputNumber
            className="full-input"
            placeholder="Ej: 1500"
          />,
        )}
      </Form.Item>
    },

    {
      key: 'price',
      item: <Form.Item key='price' className="quarter-input" label="Costo">
        {getFieldDecorator('price')(
          <InputNumber
            className="full-input"
            prefix="Bs"
            placeholder="Costo del proyecto"
            min={0}
          />,
        )}
      </Form.Item>
    },

    {
      key: 'date',
      item: <Form.Item key='date' className={mode === "agenda" ? "half-input" : "quarter-input"} label="Fecha">
        {getFieldDecorator('date')(
          <DatePicker className="full-input" showTime format="DD-MM-Y HH:mm" />,
        )}
      </Form.Item>
    },

    {
      key: 'municipality',
      item: <Form.Item key='municipality' className="half-input" label="Municipio">
        {getFieldDecorator('municipality', {
          rules: [{ required: true, message: 'El municipio es requerido' }],
        })(
          <Select
            placeholder="Municipio"
            onChange={this.setParishes}
          >
            {MUNICIPALITY.map((mun, i) =>
              <Option key={i} value={mun.id}>{mun.name}</Option>
            )}
          </Select>
        )}
      </Form.Item>
    },

    {
      key: 'location',
      item: <Form.Item key='location' className={mode === 'agenda' ? "half-input" : "half-input"} label="Parroquia">
        {getFieldDecorator('location', {
          rules: [{ required: true, message: 'La parroquia es requerida' }],
        })(
          <Select
            placeholder="Parroquia"
            onChange={this.setSectors}
            disabled={this.state.filteredParishes.length < 1}
          >
            {this.state.filteredParishes.map((p, i) =>
              < Option key={i} value={p.id} > {p.name}</Option>
            )}
          </Select>
        )}
      </Form.Item>
    },

    {
      key: 'position',
      item: <Form.Item key='position' className="half-input" label="Posición en el mapa">
        <Input.Group compact>
          <Button style={{ width: '10%' }} onClick={this.openMap} icon="plus-circle" type="primary" />
          {getFieldDecorator('position'
          )(
            <Select
              style={{ width: '90%' }}
              placeholder="Posición en el mapa"
            >
              {this.state.places.map((p, i) =>
                < Option key={p.id} value={p.id} > {p.name} ({p.lat} {p.lng}) </Option>
              )}
            </Select>

          )}
        </Input.Group>
      </Form.Item>
    },

    {
      key: 'sector',
      item: <Form.Item key='sector' className="half-input" label="Sector">
        {getFieldDecorator('sector')(
          <AutoComplete
            placeholder="Sector"
            filterOption
            disabled={this.state.sectors.length < 1}
            dataSource={this.state.sectors}
          />

        )}
      </Form.Item>
    },

    {
      key: 'address',
      item: <Form.Item key='address' className="half-input" label="Dirección">
        {getFieldDecorator('address')(
          <Input
            placeholder="Dirección"
          />
        )}
      </Form.Item>
    },

    {
      key: 'lat',
      item: <Form.Item key='lat' className="quarter-input" label="Latitud">
        {getFieldDecorator('lat', {
        })(
          <Input
            placeholder={`00°00'00,0"`}
          />,
        )}
      </Form.Item>
    },

    {
      key: 'lng',
      item: <Form.Item key='lng' className="quarter-input" label="Longitud">
        {getFieldDecorator('lng', {
        })(
          <Input
            placeholder={`00°00'00,0"`}
          />,
        )}
      </Form.Item>
    },

    {
      key: 'exec_lapses',
      item: <Form.Item key='exec_lapses' className="half-input" label="Lapsos de ejecución">
        {getFieldDecorator('exec_lapses', {
          rules: [{ required: (mode === 'planificacion'), message: 'Este campo es requerido' }],
        })(
          <RangePicker
            format="DD-MM-Y"
            className="full-input"
            onChange={this.rangePickerChange} />,
        )}
      </Form.Item>
    },

    {
      key: 'organism',
      item: <Form.Item key='organism' className="full-input" style={{ display: this.state.user.role === 1 ? 'none' : 'block' }} label="Institución responsable">
        {getFieldDecorator('organism', {
          rules: [{ required: true, message: 'Este campo es requerido' }],
          initialValue: this.state.user.role === 1 ? this.state.user.organism : null
        })(
          <Select
            className="full-input"
            placeholder="Institución"
          >
            {getChildren(getCurrentUser().organism).map((child, i) =>
              < Option key={i} value={child.id} > {child.name}</Option>
            )}
          </Select>
        )}
      </Form.Item>
    },

    {
      key: 'description',
      item: <Form.Item key='description' className="full-input" label="Descripción">
        {getFieldDecorator('description', {
          rules: [{ required: true, message: 'Este campo es requerido' }],
        })(
          <TextArea placeholder="Descripción de la actividad o proyecto" rows={2} />
        )}
      </Form.Item>
    },

    {
      key: 'pic-wall',
      item: <Form.Item key='wall' className="full-input" label="Memoria fotografica">
        <PicturesWall ref={this.wallOfPictures} className="pic-wall" />
      </Form.Item>
    },

    {
      key: 'submit',
      item: <Form.Item key='submit' className="full-input">
        <Button type="primary" htmlType="submit" className="full-input">
          Completar
			</Button>
      </Form.Item>
    }
  ].filter(item => fields.includes(item.key));

}

export const getAttachmentsIds = (attachments) => {
  let attachmentArray = [];
  attachments.forEach(attachment => {
    if (attachment.response.hasOwnProperty('success')) {
      attachmentArray.push(attachment.response.success.id);
    }
  });
  return JSON.stringify(attachmentArray);
}

const AgendaForm = Form.create({ name: 'add_agenda' })(AddAgenda);

export default AgendaForm;
